export default __webpack_public_path__ + "static/media/banner-who-we-are-mobile.c1a5c725.png";